import * as React from 'react';
import { FC } from 'react';

import SanityBlockRenderer, {
  IBlockContentOverrides,
  ISerializers,
  PassthroughComponent,
} from 'components/sanity-block-renderer';
import { isServiceRewardDetails } from 'state/loyalty/in-restaurant-redemption';

import { Name } from './styled';
import { IItemNameProps } from './types';

const nameBlockContentOverrides: IBlockContentOverrides = {
  normal: Name,
};

const nameBlockSerializers: ISerializers = {
  marks: {
    em: PassthroughComponent,
  },
  container: PassthroughComponent,
};

export const OfferItemName: FC<React.PropsWithChildren<IItemNameProps<'offer'>>> = ({
  entryCartDetails: { offer },
}) => (
  <SanityBlockRenderer
    blockContentOverrides={nameBlockContentOverrides}
    serializers={nameBlockSerializers}
    content={offer?.name?.localeRaw}
  />
);

export const RewardItemName: FC<React.PropsWithChildren<IItemNameProps<'reward'>>> = ({
  entryCartDetails,
}) => {
  const name = isServiceRewardDetails(entryCartDetails)
    ? entryCartDetails.reward.name
    : entryCartDetails.reward.name?.locale || '';

  return <Name>{name}</Name>;
};
